import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 200 200">
    <circle cx="100" cy="100" r="100" fill="#f4fffb" />
    <circle cx="100" cy="100" r="70" fill="#e6fff4" />
    <path
      d="M48 120.5c-.8-.8-1.9-1-2.9-.6s-1.6 1.4-1.6 2.4v11.6c0 1.5 1.2 2.7 2.7 2.7 1.5 0 2.6-1.2 2.6-2.7v-5.4c1 .4 2.2.3 3-.5 1-1 1-2.7 0-3.7l-3.8-3.8zM154.4 45.6c-1-.4-2.1-.2-2.9.6l-3.8 3.8c-1 1-1 2.7 0 3.7.5.5 1.2.8 1.9.8.4 0 .8-.1 1.1-.2v5.4c0 1.5 1.2 2.7 2.7 2.7 1.5 0 2.6-1.2 2.6-2.7V48c0-1.1-.6-2-1.6-2.4zM187.4 188.1l1.6-1.6c1.1-1.1 1.1-2.9 0-4s-2.9-1.1-4 0l-1.6 1.6-1.6-1.6c-1.1-1.1-2.9-1.1-4 0-.5.5-.8 1.3-.8 2 0 .8.3 1.5.8 2l1.6 1.6-1.6 1.6c-1.1 1.1-1.1 2.9 0 4 .6.6 1.3.8 2 .8s1.5-.3 2-.8l1.6-1.6 1.6 1.6c.5.5 1.2.8 2 .8s1.5-.3 2-.8c1.1-1.1 1.1-2.9 0-4l-1.6-1.6zM14.5 13.1c-1.5 0-2.7 1.2-2.7 2.7s1.2 2.7 2.6 2.7h.1c.5 0 1 .4 1 1v4.4c0 .5-.4 1-1 1h-.1c-.5 0-1-.4-1-1 0-1.5-1.2-2.7-2.7-2.7S8 22.4 8 23.9c0 3.5 2.8 6.3 6.3 6.3h.1c3.5 0 6.3-2.8 6.3-6.3v-4.4c.1-3.6-2.7-6.4-6.2-6.4zM37 188.1h-5.6c-2.6 0-4.7-2.1-4.7-4.7v-5.6c0-2.6 2.1-4.7 4.7-4.7H37c2.6 0 4.7 2.1 4.7 4.7v5.6c0 2.6-2.1 4.7-4.7 4.7zm-5.7-11.3c-.5 0-.9.4-.9.9v5.6c0 .5.4.9.9.9H37c.5 0 .9-.4.9-.9v-5.6c0-.5-.4-.9-.9-.9h-5.7z"
      fill="#c0f2d6"
    />
    <path
      d="M122.6 135.3H65.5c-.8 0-1.5-.7-1.5-1.5V70.7c0-.8.7-1.5 1.5-1.5H103c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5H67v60.1h54.1v-30c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v31.5c0 .8-.7 1.5-1.5 1.5z"
      fill="#0eb87f"
    />
    <path
      d="M107.5 75.4c-3 .4-19.7 16.3-9.2 26.8 3.7 3.7 11.9 3.1 21.8-6.8s14.3-29.1 14.3-29.1-9.7 1.4-18.6 5.3c0 0-2.3 10.8-8.3 10.8v-7z"
      fill="#c0f2d6"
    />
    <path
      d="M135.6 65.2c-.3-.4-.8-.5-1.3-.5-.4.1-10 1.4-19 5.4-.4.2-.8.6-.9 1.1 0 .1-1.7 7.5-5.3 9.2v-5.1c0-.4-.2-.8-.5-1.1-.3-.3-.8-.4-1.2-.4-2.7.3-10.4 7.5-13 15-1.7 5.1-1 9.7 2 13.4l-10.6 10.6c-.6.6-.6 1.5 0 2.1.3.3.7.4 1.1.4s.8-.1 1.1-.4l10.6-10.6c1.4.9 3.2 1.5 5.3 1.5 4.6 0 10.7-2.7 17.4-9.3 10.1-10.1 14.5-29 14.7-29.8.1-.6-.1-1.1-.4-1.5zm-16.4 29.1c-8 8-14.7 9.6-18.4 7.8l14.5-14.5c.6-.6.6-1.5 0-2.1-.6-.6-1.5-.6-2.1 0l-14.7 14.7c-2.1-2.6-2.6-5.8-1.6-9.4 1.6-5.6 6.4-10.6 9.1-12.8v4.4c0 .8.7 1.5 1.5 1.5 6.2 0 8.9-8.5 9.6-11.2 5.9-2.5 12.1-3.9 15.3-4.5-1.4 5.2-5.7 18.5-13.2 26.1z"
      fill="#0eb87f"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/empty-content.es6.js